import { timeRangeOptions, financeProfitReportCurrency } from "@/utils/options";

const dateTypeOptions = [
    {id: '1', text: '结算周期'},
    {id: '2', text: '转账日期'},
]

const transferOptions = [
    {id: '1', text: '成功'},
    {id: '2', text: '失败'},
    {id: '3', text: '未知'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '全部店铺',
    prop: 'marketIds',
    components: [{
        name: 'gj-market-select',
        prop: 'marketIds',
        propsData: {
            placeholder: '全部店铺',
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '全部转账状态',
    prop: 'transferStatus',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'transferStatus',
        propsData: {
            placeholder: '全部转账状态',
            options: transferOptions
        }
    }],
    defaultValue: ''
}, {
    label: '币种',
    prop: 'currency',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'currency',
        propsData: {
            placeholder: '币种',
            options: financeProfitReportCurrency
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: '1'
}]
